import { useCallback } from 'react';
import { useAuthContext } from '../auth/useAuthContext';
import { standardFBExpiredMessage } from '../redux/store';

export type EndSessionCallback = (error: any) => void;

//? In the case that a request is preformed without the use of RTK Query, this hook will handle an expired user session and call logout.
export function useExpiredSessionErrorToNavigate(): EndSessionCallback {
  const { logout } = useAuthContext();

  return useCallback(
    (error: any) => {
      if (error.message === standardFBExpiredMessage) {
        logout();
      }
    },
    [logout]
  );
}
